import { useApprovalContext } from 'ui-product-approvals/hooks/useApprovalContext';
const useGetIsApprovalsEnabled = () => {
  const approval = useApprovalContext();
  const isApprovalsEnabled = approval && approval.config && approval.config.enabled;
  return !!isApprovalsEnabled;
};
export default useGetIsApprovalsEnabled;